import { Grid, Stack, TextField } from "@mui/material";
import ImageUpload from "../../../../components/ImageUpload";
import FeatureCard from "./FeatureCard";

export default function StepOne({ asset, setAsset }) {

  const handleChange = (event) => {
    const newAsset = { ...asset, [event.target.id]: event.target.value };
    setAsset(newAsset);
  }

  const handleFileUploadChange = (file) => {
    const newAsset = { ...asset, Image: file };
    setAsset(newAsset);
  };

  return (
    <Grid container sx={{ flexDirection: "row", gap: 4 }}>
      <Grid item xs={12} sm={5} sx={{ justifyContent: "center", alignItems: "center" }}>
        <FeatureCard asset={asset} />
      </Grid>
      <Grid item xs>
        <Stack direction={"column"} gap={4}>
          <TextField
            id="Title"
            label="Title"
            fullWidth
            value={asset.Title}
            onChange={(event) => {
              handleChange(event);
            }}
          />
          <TextField
            id="privateId"
            label="Private Asset ID"
            fullWidth
            value={asset.privateId}
            onChange={(event) => {
              handleChange(event);
            }}
          />
          <ImageUpload  value={asset.Image} onChange={handleFileUploadChange}/>
        </Stack>
      </Grid>
    </Grid>
  );
}
